// App.js
import React, { Component } from 'react';
import { Container, Table, Row, Col } from 'reactstrap';

export class PaysheetData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            metadata: [
                { label: 'Payment Week', value: '3/30/25 - 4/05/25' },
                { label: 'Check Date', value: '2025-04-11' }
            ],
            headers: [
                'Locations',
                'Name of Client',
                'Name of Routes',
                'First and Last',
                'Pay on Routes',
                'Total Route Count',
                'Total',
                'Comments on the Driver',
                'Transaction Type',
                'Live Check',
                'Day Run'
            ],
            data: [
                [
                    'WP/ALCT',
                    'WorldPac ATL Central',
                    'LB #1 ATL Central',
                    'Test 1',
                    '$200',
                    '5',
                    '$405',
                    'Great performance',
                    'Day Run',
                    '',
                    'Yes'
                ],
                [
                    'WP/NW',
                    'WorldPac Northwest',
                    'LB #2 Northwest',
                    'Test 2',
                    '$180',
                    '4',
                    '$320',
                    'Needs improvement',
                    'Night Run',
                    '',
                    'No'
                ]
            ]
        };
    }

    render() {
        const { metadata, headers, data } = this.state;

        return (
            <Container className="mt-4">
                <h2>Routes Data</h2>

                {/* Metadata Section */}
                <Row className="mb-3">
                    {metadata.map((item, index) => (
                        <Col xs="12" md="6" key={index}>
                            <strong>{item.label}:</strong> {item.value}
                        </Col>
                    ))}
                </Row>

                {/* Table Section */}
                <Table bordered responsive>
                    <thead>
                        <tr>
                            {headers.map((head, i) => (
                                <th key={i}>{head}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {headers.map((_, colIndex) => (
                                    <td key={colIndex}>{row[colIndex] || ''}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        );
    }
}
